/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { paymentResponseSchema } from "./paymentResponseSchema.ts";

export const initPaymentResponseSchema = z
	.object({
		url: z.url().nullable(),
		payments: z.array(paymentResponseSchema),
	})
	.describe("url is nullable for payments from kiosk");
